import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as $, useRef as G, useImperativeHandle as J, useMemo as K } from "react";
import { f as I } from "./index-LyFokDcn.mjs";
import { l as Q } from "./lodash-5ofSKtz3.mjs";
import { I as U, a as X, N as Y } from "./input-wrapper-qaVcukod.mjs";
import { u as Z } from "./use-readable-context-BO-ExsvT.mjs";
import { S as q } from "./select-DjbIs9Ff.mjs";
import { m as ee } from "./tss-DN0acMKN.mjs";
import { F as re } from "./form-note-CbSVsgBQ.mjs";
import { L as ae } from "./layout-box-DFBM-kSI.mjs";
import { g as te } from "./get-aria-describedby-G1wcWKF2.mjs";
import { F as ie } from "./FormControl-C7vROVtA.mjs";
import { g as ne } from "./get-status-message-CGqgCpjJ.mjs";
const oe = ee({ name: "SelectField" })((s, y) => {
  const { palette: r, spacing: c, typography: x } = s, { labelPlacement: u, notePlacement: w, type: d, size: S, status: e } = y, m = {
    teenie: "32px",
    small: "32px",
    medium: "40px",
    large: "48px",
    biggie: "48px"
  }, v = (p) => {
    switch (p) {
      case "error":
        return r.error.main;
      case "warning":
        return r.warning.main;
      case "info":
        return r.info.main;
      default:
        return r.gray[800];
    }
  };
  return I.ifFeature(
    "encore",
    {
      root: {
        alignItems: u === "inline" && w === "inline" && d === "text" ? "center" : void 0
      },
      label: {
        height: u === "inline" && d !== "text" ? m[S ?? "medium"] : void 0
      },
      error: {},
      warning: {},
      info: {},
      note: {}
    },
    {
      root: {},
      label: {
        display: "flex",
        alignItems: "center",
        fontSize: x.fabricFontSize("small"),
        lineHeight: 1,
        whiteSpace: "nowrap",
        "&>svg": {
          marginRight: c(0.75)
        },
        "& > .MuiInputLabel-asterisk": {
          color: r.primary.main
        },
        "&.Mui-focused": {
          color: e ? v(e) : r.gray[800]
        },
        pointerEvents: "auto"
      },
      error: {
        color: r.error.main,
        fill: r.error.main
      },
      warning: {
        color: r.warning.main,
        fill: r.warning.main
      },
      info: {
        color: r.info.main,
        fill: r.info.main
      },
      note: {}
      // needed for props checking
    }
  );
}), we = $((s, y) => {
  const { isReadable: r } = Z();
  let c = s;
  const { apiRef: x, ariaDescribedby: u, containerRef: w, errorMessage: d, warningMessage: S, status: e, type: m } = s;
  if (r || m === "view") {
    const { placeholder: f, isClearable: H, ...o } = s;
    c = { ...o, isClearable: I.ifFeature("encore", !!e, !1), type: "view" };
  }
  const {
    afterLabel: v,
    ariaLabel: p,
    canSelectMultiple: F,
    className: B,
    disabled: j,
    isDisabled: O,
    label: a,
    labelPlacement: L = "block",
    listenToItemsOnChange: T,
    note: M,
    notePlacement: R = "inline",
    onChange: A,
    required: g,
    searchPlaceholder: D,
    value: l,
    variant: P,
    width: C = 100,
    ...z
  } = c, i = c.id || Q.uniqueId("fab-select");
  let b = [];
  Array.isArray(l) ? b = l : typeof l > "u" || l === null || (b = [l]);
  const k = (f, H) => {
    if (typeof A == "function") {
      let o = f;
      T && (o = H), Array.isArray(o) && !Array.isArray(l) && !F && ([o] = o), A({ target: { value: o } });
    }
  }, h = j || O, { size: W } = s, { classes: n, cx: _ } = oe({ labelPlacement: L, notePlacement: R, size: W, status: e, type: m }), N = G(null);
  J(
    x,
    () => ({
      focus: () => {
        const { current: f } = N;
        f && f.focus();
      }
    }),
    []
  );
  const V = K(() => `fabric-selectfield-status-message-${i}`, []), E = ne(e, d, S);
  return I.ifFeature(
    "encore",
    /* @__PURE__ */ t.jsx(
      U,
      {
        afterLabel: v,
        classes: { root: n.root, label: n.label },
        "data-fabric-component": "SelectField",
        disabled: j,
        id: i,
        label: a,
        labelPlacement: L,
        note: M,
        notePlacement: R,
        ref: w,
        required: g,
        status: e,
        statusMessage: E,
        statusMessageId: V,
        variant: P,
        viewMode: m === "view",
        width: C,
        children: /* @__PURE__ */ t.jsx(
          q,
          {
            ariaDescribedby: te(E ? V : "", u),
            ariaLabel: p || (typeof a == "string" ? a : ""),
            canSelectMultiple: F,
            condition: e,
            inputRef: N,
            isDisabled: h,
            name: i,
            required: g,
            ...z,
            id: i,
            onChange: k,
            searchPlaceholder: D,
            selectedValues: b,
            variant: P,
            width: C
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsxs(ie, { className: B, error: e === "error", ref: y, children: [
      a && /* @__PURE__ */ t.jsx(
        X,
        {
          classes: {
            root: _({
              [n.label]: !0,
              [n.error]: e === "error",
              [n.warning]: e === "warning",
              [n.info]: e === "info"
            })
          },
          disabled: h,
          error: e === "error",
          htmlFor: i,
          required: g,
          shrink: !0,
          children: a
        }
      ),
      /* @__PURE__ */ t.jsxs(Y, { inputHasLabel: !!a, children: [
        /* @__PURE__ */ t.jsx(
          q,
          {
            ariaLabel: p || (typeof a == "string" ? a : ""),
            canSelectMultiple: F,
            condition: e,
            isDisabled: h,
            name: i,
            required: g,
            ...z,
            id: i,
            onChange: k,
            searchPlaceholder: D,
            selectedValues: b,
            width: C
          }
        ),
        /* @__PURE__ */ t.jsx(re, { classes: { root: n.note }, disabled: h, status: e, children: /* @__PURE__ */ t.jsx(ae, { marginLeft: 1, children: M }) })
      ] })
    ] })
  );
});
export {
  we as S
};
//# sourceMappingURL=select-field-BuE_t-Fz.mjs.map
